import React from 'react'
import { IoCloseOutline } from "react-icons/io5";
import { Link, NavLink } from 'react-router-dom';
import { TbHeart } from "react-icons/tb";
import { AiOutlineUser } from "react-icons/ai";
import { AnimatePresence, motion } from 'framer-motion';
import { useUserContext } from '../../context/UserContext';
import { navLinks } from '../../helpers/config';



function MobileNav({ isNavOpen, callback }) {

    const { user } = useUserContext();

    return (
        <>
            <AnimatePresence>
                {isNavOpen && (
                    <motion.div
                        initial={{ x: -1000 }}
                        animate={{ x: 0 }}
                        transition={{ duration: 0.2 }}
                        exit={{ x: -1000 }}
                        className='w-full bg-white fixed h-full top-0 left-0 z-[99999] lg:hidden'
                    >
                        {/* Head */}
                        <div className="bg-orange-600 px-5 sm:px-8 py-4 flex items-center justify-between">
                            <h5 className="text-white">Menu</h5>
                            <button className='text-gray-300' onClick={() => callback()}>
                                <IoCloseOutline size={25} />
                            </button>
                        </div>

                        {/* Navs */}
                        <div className="w-full px-5 sm:px-8">
                            <ul className="flex flex-col font-medium">
                                {navLinks.map((link, i) => (
                                    <li key={i} className='py-4 border-b'>
                                        <NavLink onClick={() => callback()} to={link.path}>{link.title}</NavLink>
                                    </li>
                                ))}
                                <li className='py-4 border-b'>
                                    <Link onClick={() => callback()} to="/wishlist" className="flex items-center gap-3">
                                        <TbHeart size={20} />
                                        <h4>Wishlist</h4>
                                    </Link>
                                </li>
                                <li className='py-4 border-b'>
                                    <Link onClick={() => callback()} to="/account" className="flex items-center gap-3">
                                        <AiOutlineUser size={20} />
                                        {user && user?.firstname ?
                                            (<h4>{user && user?.firstname + " " + user?.lastname}</h4>) :
                                            (<h4>Login / Register</h4>)
                                        }
                                    </Link>
                                </li>
                                <li className='py-4 border-b'>
                                    <Link onClick={() => callback()} to={'/account/logout'}>Logout</Link>
                                </li>
                            </ul>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    )
}

export default MobileNav



